/**
 * PP Cart Recommendations — loads and re-loads related products
 * inside [data-cart-reco] containers.
 *
 * Survives morph: uses a MutationObserver on <body> to detect when
 * [data-cart-reco] appears with an empty [data-cart-reco-list], then
 * re-fetches and re-renders the products.
 */
(function () {
  if (window.__ppCartRecoInit) return;
  window.__ppCartRecoInit = true;

  /* =========================================================================
     AÑADIR upsell — handler ROBUSTO (igual de fiable que el botón de las
     product cards). Se registra el PRIMERO, en fase de CAPTURA sobre document,
     así intercepta el clic del "+" ANTES que cualquier otra cosa (el
     drag-suppress del slider, delegaciones, etc.) y hace stopImmediatePropagation
     para que nada más interfiera ni lo duplique. Nunca se pierde el clic.
     ========================================================================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pp-cart-reco__add[data-cart-reco-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    btn.style.opacity = '0.5';
    triggerAdd(btn, variantId); // función declarada más abajo (hoisted)
  }, true);

  function loadReco(root) {
    if (!root || root.dataset.ppRecoLoaded) return;
    root.dataset.ppRecoLoaded = '1';

    var list = root.querySelector('[data-cart-reco-list]');
    if (!list) return;

    // If SSR'd (has children already), skip fetch
    if (list.children.length > 0) return;

    var hasCollection = !!root.dataset.collectionHandle;
    var productId = root.dataset.productId;
    var limit = parseInt(root.dataset.limit, 10) || 8;

    if (hasCollection || !productId) return;

    var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) {
          root.style.display = 'none';
          return;
        }
        list.innerHTML = data.products
          .map(function (p) {
            var variant = p.variants[0];
            var img = p.featured_image
              ? p.featured_image.replace(/(\.[^.?]+)(\?.*)?$/, '_400x$1$2')
              : '';
            var onSale = p.compare_at_price && p.compare_at_price > p.price;
            var discPct = onSale
              ? Math.round(((p.compare_at_price - p.price) * 100) / p.compare_at_price)
              : 0;
            var isSimple = p.variants.length === 1;
            var available = variant && variant.available;

            var addBtn = '';
            var variantsData = '';
            if (available) {
              if (isSimple) {
                addBtn =
                  '<button type="button" class="pp-cart-reco__add" data-cart-reco-add data-variant-id="' +
                  variant.id + '" aria-label="Añadir">+</button>';
              } else {
                addBtn =
                  '<button type="button" class="pp-cart-reco__add" data-cart-reco-variants data-product-title="' +
                  escapeHtml(p.title) + '" aria-label="Elegir opción">+</button>';
                variantsData =
                  '<script type="application/json" data-reco-variants-data>' +
                  JSON.stringify(p.variants.map(function (v) {
                    return { id: v.id, title: v.title, price: money(v.price), available: !!v.available };
                  })) +
                  '<\/script>';
              }
            }

            return '<div class="pp-cart-reco__card">' +
              '<div class="pp-cart-reco__media-wrap">' +
                '<a href="' + p.url + '" class="pp-cart-reco__media">' +
                (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" class="pp-cart-reco__img">' : '') +
                '</a>' +
                (discPct > 0 ? '<span class="pp-cart-reco__badge">-' + discPct + '%</span>' : '') +
                addBtn + variantsData +
              '</div>' +
              '<a href="' + p.url + '" class="pp-cart-reco__name">' + escapeHtml(p.title) + '</a>' +
              '<div class="pp-cart-reco__prices">' +
                '<span class="pp-cart-reco__price">' + money(p.price) + '</span>' +
                (onSale ? '<s class="pp-cart-reco__compare">' + money(p.compare_at_price) + '</s>' : '') +
              '</div>' +
            '</div>';
          })
          .join('');
        syncAll();
      })
      .catch(function () {
        root.style.display = 'none';
      });
  }

  // Init all existing containers
  function initAll() {
    document.querySelectorAll('[data-cart-reco]').forEach(function (el) {
      loadReco(el);
    });
  }

  // Watch for morph re-injecting the container (empty).
  // INP: en vez de escanear en CADA mutación del DOM (caro durante interacciones),
  // agrupamos en una sola pasada por frame (debounce) y observamos solo el cart
  // drawer si existe, en lugar de todo el <body>.
  var recoScanScheduled = false;
  function scheduleRecoScan() {
    if (recoScanScheduled) return;
    recoScanScheduled = true;
    (window.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(function () {
      recoScanScheduled = false;
      document.querySelectorAll('[data-cart-reco]').forEach(function (el) {
        if (!el.dataset.ppRecoLoaded) loadReco(el);
      });
    });
  }
  var observer = new MutationObserver(scheduleRecoScan);
  var recoTarget = document.querySelector('cart-drawer-component') || document.body;
  observer.observe(recoTarget, { childList: true, subtree: true });

  // Expose global function for inline onclick handlers on recommendation buttons.
  // This bypasses any event-delegation issues with other scripts stopping propagation.
  window.ppCartRecoAdd = function (btn, variantId) {
    console.log('[pp-cart-reco] add via inline onclick', variantId);
    if (!variantId || (btn && btn.disabled)) return;
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = '0.5';
    }
    triggerAdd(btn, variantId);
  };

  function triggerAdd(btn, variantId) {

    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id) sectionIds.push(id);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Visual feedback — swap "+" to check briefly
        btn.classList.add('is-added');
        btn.textContent = '✓';
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = '+';
        }, 1200);

        // Refresh drawer content so quantities + line items update
        if (typeof window.ppRefreshCartDrawer === 'function') {
          try {
            var p = window.ppRefreshCartDrawer({ open: true });
            if (p && typeof p.catch === 'function') {
              p.catch(function (err) { console.warn('[pp-cart-reco] refresh failed:', err); });
            }
          } catch (e) { console.warn('[pp-cart-reco] refresh threw:', e); }
        }

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: data, source: 'pp-cart-reco', sections: data.sections },
        }));

        // Update free shipping bar + count
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('pp-free-shipping-bar').forEach(function (el) {
              el.dataset.totalPrice = String(cart.total_price);
              if (typeof el._render === 'function') el._render();
            });
            document.querySelectorAll('.pp-header__cart-count, [data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function () {});
      })
      .catch(function (err) { console.warn('[pp-cart-reco] add failed:', err); })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.style.opacity = '';
        }
      });
  }

  // Bonus delegation fallback (for any button that was already rendered)
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-cart-reco-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    btn.style.opacity = '0.5';
    triggerAdd(btn, variantId);
  }, true);

  /* ---------- Utilidades ---------- */
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function money(cents) {
    return window.Shopify && window.Shopify.formatMoney
      ? window.Shopify.formatMoney(cents)
      : (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- Plegar / desplegar (recuerda el estado en la sesión) ---------- */
  var COLLAPSE_KEY = 'ppCartRecoCollapsed';

  function applyCollapsed(root) {
    var btn = root.querySelector('[data-cart-reco-toggle]');

    // Con 2 artículos o menos en el carrito, los upsells se muestran siempre
    // desplegados (ignora el estado guardado en sesión).
    var itemCount = parseInt(root.getAttribute('data-cart-item-count'), 10);
    if (!isNaN(itemCount) && itemCount <= 2) {
      root.classList.remove('is-collapsed');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      return;
    }

    var collapsed = false;
    try { collapsed = sessionStorage.getItem(COLLAPSE_KEY) === '1'; } catch (e) {}
    if (!collapsed) return;
    root.classList.add('is-collapsed');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-cart-reco-toggle]');
    if (!btn) return;
    ev.preventDefault();
    var root = btn.closest('[data-cart-reco]');
    if (!root) return;
    var collapsed = root.classList.toggle('is-collapsed');
    btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    try { sessionStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0'); } catch (e) {}
    if (!collapsed) setTimeout(syncAll, 340); // tras la transición de apertura
  });

  /* ---------- Barra de progreso del scroll ---------- */
  function syncScrollbar(root) {
    var track = root.querySelector('[data-cart-reco-list]');
    var bar = root.querySelector('[data-reco-scrollbar]');
    var thumb = root.querySelector('[data-reco-thumb]');
    if (!track || !bar || !thumb) return;

    var max = track.scrollWidth - track.clientWidth;
    if (max <= 1) { bar.classList.add('is-hidden'); return; }
    bar.classList.remove('is-hidden');

    var ratio = track.clientWidth / track.scrollWidth;
    thumb.style.width = Math.max(ratio * 100, 12) + '%';
    var travel = bar.clientWidth - thumb.clientWidth;
    thumb.style.transform = 'translateX(' + (track.scrollLeft / max) * travel + 'px)';
  }

  /* ---------- Arrastre con ratón en desktop ("grabeable") ----------
     El track solo tenía scroll-snap horizontal, que en touch/trackpad
     funciona pero en desktop (sin trackpad) no había forma de moverlo:
     clic y arrastrar como si fuera una tarjeta física. */
  function bindDesktopScroll(track) {
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    var pointerId = null;
    track.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'touch') return; // el touch ya tiene scroll nativo
      if (ev.button !== undefined && ev.button !== 0) return; // solo botón izquierdo
      isDown = true;
      moved = false;
      startX = ev.clientX;
      startScroll = track.scrollLeft;
      pointerId = ev.pointerId;
      // OJO: NO capturamos el puntero aquí. Si lo hacíamos, un simple clic en el "+"
      // se lo quedaba el track (setPointerCapture redirige el click) y el botón nunca
      // recibía el click → "casi nunca funcionaba". Capturamos solo si hay ARRASTRE real.
    });

    track.addEventListener('pointermove', function (ev) {
      if (!isDown) return;
      var dx = ev.clientX - startX;
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(pointerId); } catch (e) {} // capturar solo al arrastrar
      }
      if (moved) {
        ev.preventDefault();
        track.scrollLeft = startScroll - dx;
      }
    });

    function endDrag(ev) {
      if (!isDown) return;
      isDown = false;
      // Deja que el navegador asiente el scroll antes de reactivar el snap,
      // si no la reactivación inmediata "salta" hacia atrás.
      requestAnimationFrame(function () { track.classList.remove('is-dragging'); });
      // Si hubo arrastre real, evita que el click posterior en una card/enlace se dispare.
      if (moved) {
        var suppressClick = function (e) { e.preventDefault(); e.stopPropagation(); track.removeEventListener('click', suppressClick, true); };
        track.addEventListener('click', suppressClick, true);
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    // Evita el drag nativo del navegador sobre imágenes/enlaces dentro del track,
    // que compite con el pointer-drag y "engancha" la imagen en vez de deslizar.
    track.addEventListener('dragstart', function (ev) { ev.preventDefault(); });
  }

  function syncAll() {
    document.querySelectorAll('[data-cart-reco]').forEach(function (root) {
      if (!root.dataset.ppRecoBound) {
        root.dataset.ppRecoBound = '1';
        var track = root.querySelector('[data-cart-reco-list]');
        if (track) {
          track.addEventListener('scroll', function () { syncScrollbar(root); }, { passive: true });
          bindDesktopScroll(track);
        }
        applyCollapsed(root);
      }
      syncScrollbar(root);
    });
  }

  window.addEventListener('resize', syncAll);

  /* ---------- Pop-up de selección de variante ---------- */
  function getModal() { return document.querySelector('[data-reco-modal]'); }

  function openVariantModal(btn) {
    var modal = getModal();
    if (!modal) return;

    var wrap = btn.closest('.pp-cart-reco__media-wrap');
    var dataEl = wrap && wrap.querySelector('[data-reco-variants-data]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var titleEl = modal.querySelector('[data-reco-modal-title]');
    if (titleEl) titleEl.textContent = btn.getAttribute('data-product-title') || '';

    var list = modal.querySelector('[data-reco-modal-list]');
    if (list) {
      list.innerHTML = variants.map(function (v) {
        return '<button type="button" class="pp-reco-modal__option" data-reco-variant-id="' + v.id + '"' +
          (v.available ? '' : ' disabled') + '>' +
          '<span>' + escapeHtml(v.title) + '</span>' +
          '<span class="pp-reco-modal__option-price">' + escapeHtml(v.price) + '</span>' +
          '</button>';
      }).join('');
    }

    modal.hidden = false;
    modal.__ppTrigger = btn;
  }

  function closeVariantModal() {
    var modal = getModal();
    if (modal) modal.hidden = true;
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    var openBtn = t.closest('[data-cart-reco-variants]');
    if (openBtn) { ev.preventDefault(); openVariantModal(openBtn); return; }

    if (t.closest('[data-reco-modal-close]')) { ev.preventDefault(); closeVariantModal(); return; }

    var opt = t.closest('[data-reco-variant-id]');
    if (opt && !opt.disabled) {
      ev.preventDefault();
      var modal = getModal();
      var trigger = (modal && modal.__ppTrigger) || opt;
      closeVariantModal();
      triggerAdd(trigger, opt.getAttribute('data-reco-variant-id'));
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closeVariantModal();
  });

  initAll();
  syncAll();
})();
